export default __webpack_public_path__ + "static/media/a.8a932c2a.png";